import React, { lazy, Suspense } from 'react';
import { Switch, Route } from "react-router-dom";
import PATHS from "constants/paths"; 
import Loader from "components/general/Loader";

const NotFound = lazy(() => import( "pages/NotFound" ));
const Reservation = lazy(() => import("pages/Reservation" ));
const ReservationActions = lazy(() => import ( "pages/ReservationActions" ));
const Payment = lazy(() => import( "pages/Payment" ));
const PaymentFinish = lazy(() => import( "pages/PaymentFinish" ));
const UserManual = lazy(() => import( "pages/UserManual" ));
const AccessibilityDeclaration = lazy(() => import( "pages/AccessibilityDeclaration" ));
const Terms = lazy(() => import( "pages/Terms" ));
const PrivacyPolicy = lazy(() => import( "pages/PrivacyPolicy" ));

export default function Routes() {
	return (		
		<Suspense fallback={ <Loader style={{ height: "100%" }}/> }>
			<Switch>
				<Route exact path={ PATHS.MAIN } component={ Reservation } />
				<Route exact path={ PATHS.RESERVATION_ACTIONS } component={ ReservationActions } />
				<Route exact path={ PATHS.PAYMENT } component={ Payment } />
				<Route exact path={ PATHS.PAYMENT_FINISH } component={ PaymentFinish } />
				<Route exact path={ PATHS.USER_MANUAL } component={ UserManual } />
				<Route exact path={ PATHS.ACCESSIBILITY_DECLARATION } component={ AccessibilityDeclaration }/>
				<Route exact path={ PATHS.TERMS } component={ Terms } />
				<Route exact path={ PATHS.PRIVACY_POLICY } component={ PrivacyPolicy } />
				<Route component={ NotFound } />
			</Switch>
		</Suspense>
	)
}